import Box from '@mui/material/Box';

import List from '@mui/material/List';
import {
    BottomNavigation,
    Profile,
    Profile1,
    Shopping,
    Shopping1,
    Walle,
    Wallet,
} from '@kaman/uikit';

import {GATEWAY_PAYMENT_TOKEN} from '../../config/cacheKey';
import {CSSProperties, useEffect, useRef, useState} from 'react';
import './bottomNavigation.css';
import LoansContainer from '../../pages/navigationButtonComponents/loansTab/loansContainer';
import MenuContainer from '../../pages/menuTab/profile/menuContainer';
import StoreContainer from '../../pages/navigationButtonComponents/walletContainer/storeContainer';
import HomeMenuContainer from '../../pages/navigationButtonComponents/homeTab/homeMenuContainer';
import SheetLayout from '../../layouts/sheetLayout';
import Home from '../../pages/home/home';
import BranchesList from '../../pages/home/branches/branchesList';
import StoreDetail from '../../pages/home/storeDetail';
import {useSelector} from 'react-redux';
import {useQuery, useQueryClient} from 'react-query';
import {GetCustomerInfo} from '../../services/customer.service';
import {RootState} from '../../redux/store';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate,
} from 'react-router-dom';
import OfflineSearch from '../../pages/home/search/offlineSearch';
import OnlineSearch from '../../pages/home/search/onlineSearch';
import ProductPreview from '../../pages/home/components/productPreview';
import {WorkflowLoading} from '../../pages/navigationButtonComponents/loansTab/containerApp/LoanWorkflowGuard';

export default function FixedBottomNavigation() {
    const location = useLocation();
    const [entryReady, setEntryReady] = useState(false);
    const navigate = useNavigate();
    const pathToTab =
        location.pathname.startsWith('/account') ||
        location.pathname.startsWith('/menu')
            ? 2
            : location.pathname.startsWith('/credit') ||
                location.pathname.startsWith('/market') ||
                location.pathname.startsWith('/loans')
              ? 1
              : 0;
    const value = pathToTab;
    const ref = useRef<HTMLDivElement>(null);
    const queryClient = useQueryClient();

    const {data: profile, isLoading} = useQuery(
        'customerInfo',
        GetCustomerInfo,
        {
            staleTime: 1000 * 60 * 30,
            cacheTime: 1000 * 60 * 60,
            refetchOnWindowFocus: false,
        }
    );

    queryClient.setQueryData('PROFILE_INFO', {profile, isLoading});
    const prevRoute = useSelector(
        (state: RootState) => state.loansTabComponents.prevState
    );

    useEffect(() => {
        if (prevRoute === 'loans12') {
            navigate('/loans/request/confirmLoanTemplate');
            return;
        }
    }, [prevRoute]);

    useEffect(() => {
        const params = new URLSearchParams(
            new URL(window.location.href).search
        );
        const target = params.get('target');
        queryClient.setQueryData('URL_PARAMS', {
            param: window.location.pathname,
            token: params,
        });
        //route from kaman
        const substrings = ['registerLoan', 'loans', 'requestLoan'];

        if (substrings.some((sub) => target?.includes(sub))) {
            if (!location.pathname.startsWith('/loans'))
                navigate('/loans', {replace: true});
        } else if (target?.includes('store')) {
            navigate('/market', {replace: true});

            // const newCleanUrl = window.location.pathname + window.location.hash;
            // window.history.replaceState(null, '', newCleanUrl);
        } else if (target?.includes('wallet')) {
            navigate('/market/wallet', {replace: true});
        } else if (target?.includes('trade')) {
            navigate('/credit/trade', {replace: true});
            const newCleanUrl = window.location.pathname + window.location.hash;
            window.history.replaceState(null, '', newCleanUrl);
        } else if (window.location.pathname.includes('installmentPayment')) {
            navigate('/loans/installments/installmentPayment', {replace: true});
            const newCleanUrl = window.location.pathname + window.location.hash;
            window.history.replaceState(null, '', newCleanUrl);
        } else if (window.location.pathname.includes('OnlinePrePayment')) {
            navigate('/loans/request', {replace: true});
            queryClient.setQueryData('ONLINE_PREPAYMENT', 'onlinePrepayment');
            const newCleanUrl = window.location.pathname + window.location.hash;
            window.history.replaceState(null, '', newCleanUrl);
        }
        setEntryReady(true);
    }, []);

    const navigateToTab = (tab: number) => {
        navigate(['/home', '/credit', '/account'][tab] || '/home');
    };

    const navigateLegacyDestination = (tab: number) => {
        navigate(
            (
                {1: '/market', 2: '/loans', 3: '/account'} as Record<
                    number,
                    string
                >
            )[tab] || '/credit'
        );
    };

    const navigationItems = [
        {
            label: 'فروشگاه',
            active: value === 0,
            icon:
                value === 0 ? (
                    <Shopping1 size={18} className="text-gray-900" />
                ) : (
                    <Shopping size={18} />
                ),
            onClick: () => {
                localStorage.removeItem(GATEWAY_PAYMENT_TOKEN);
                navigateToTab(0);
            },
        },
        {
            label: 'اعتبار من',
            active: value === 1,
            icon:
                value === 1 ? (
                    <Wallet size={20} className="text-gray-900" />
                ) : (
                    <Walle size={18} className="text-gray-900" />
                ),
            onClick: () => {
                localStorage.removeItem(GATEWAY_PAYMENT_TOKEN);
                navigateToTab(1);
            },
        },
        {
            label: 'حساب من',
            active: value === 2,
            icon:
                value === 2 ? (
                    <Profile1 size={16} className="text-gray-900" />
                ) : (
                    <Profile size={18} />
                ),
            onClick: () => {
                localStorage.removeItem(GATEWAY_PAYMENT_TOKEN);
                navigateToTab(2);
            },
        },
    ];

    if (!entryReady) return <WorkflowLoading />;
    return (
        <Box sx={{pb: 12}} ref={ref}>
            <List disablePadding>
                <Routes>
                    <Route path="/home" element={<SheetLayout />}>
                        <Route index element={<Home />} />
                        <Route path="branches" element={<BranchesList />} />
                        <Route path="store-detail" element={<StoreDetail />} />
                        <Route
                            path="offline-search"
                            element={<OfflineSearch />}
                        />
                        <Route
                            path="online-search"
                            element={<OnlineSearch />}
                        />
                        <Route
                            path="product-preview"
                            element={<ProductPreview />}
                        />
                        <Route
                            path="store-detail/branches"
                            element={<BranchesList />}
                        />
                        <Route
                            path="*"
                            element={<Navigate to="/home" replace />}
                        />
                    </Route>
                    <Route
                        path="/credit/*"
                        element={
                            <HomeMenuContainer
                                setTabChild={navigateLegacyDestination}
                            />
                        }
                    />
                    <Route
                        path="/account/*"
                        element={
                            <MenuContainer
                                setTabChild={navigateLegacyDestination}
                            />
                        }
                    />
                    <Route
                        path="/market/*"
                        element={
                            <StoreContainer
                                setTabChild={navigateLegacyDestination}
                            />
                        }
                    />
                    <Route
                        path="/loans/*"
                        element={
                            <LoansContainer
                                setTabChild={navigateLegacyDestination}
                            />
                        }
                    />
                    <Route
                        path="/menu/*"
                        element={<Navigate to="/account" replace />}
                    />
                    <Route path="*" element={<Navigate to="/home" replace />} />
                </Routes>
            </List>
            <BottomNavigation
                items={navigationItems}
                className="kaman-bottom-navigation"
                style={
                    {
                        '--active-tab': value,
                        position: 'fixed',
                        width: 'calc(100% - 30px)',
                        maxWidth: '520px',
                        margin: 'auto',
                        zIndex: 1220,
                        bottom: '10px',
                        left: '15px',
                        right: '15px',
                        border: '0.5px solid #EDEDED',
                        borderRadius: '32px',
                        backgroundColor: '#FFFFFF',
                        boxShadow:
                            '0 4px 60px rgba(143, 143, 143, 0.10), 0 0 2px rgba(139, 139, 139, 0.20)',
                    } as CSSProperties
                }
                id="fixed-bottom-navigation"
            />
        </Box>
    );
}
